import React from 'react';
import { Controller } from 'react-hook-form';
import { FormControl, FormControlLabel, Checkbox, FormHelperText, FormGroup } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
const CheckboxController = ({isCustomColorForFoot=false, isCustomPadding, size="medium", name, label, control, errors, options, isMultiCheckbox = false, isRow=false, isHorizantalPadding=false, isDisabled=false, isMarginLeft=false, 
isMargin=true, specialTick=false }) => {
    return (

        <>
            {isMultiCheckbox ? <>
                <FormControl error={Boolean(errors[name])}>
                    <Controller
                        name={name}
                        control={control}
                        render={({ field: { onChange, value }, fieldState: { error } }) => (
                            <>
                            <FormGroup row={isRow}>
                                {options.map((option, index) => (
                                    <FormControlLabel
                                    sx={{
                            "& .MuiCheckbox-root": {
                              color: isCustomColorForFoot
                                ? (theme) => theme.palette.error.main
                                : "",
                              backgroundColor: isCustomColorForFoot
                                ? "#fff"
                                : "",
                              padding: isCustomColorForFoot ? "0px" : isCustomPadding ?  "0px 5px" : "6px 0px",
                            },
                            "& .MuiCheckbox-root.Mui-checked": {
                              color: isCustomColorForFoot
                                ? "#47b749"
                                : "",
                            },
                            "& .MuiFormControlLabel-label.Mui-disabled": {
                              color: (theme) => theme.palette.black.main,
                            },
                            "&.MuiFormControlLabel-root": {
                              marginLeft: isMarginLeft ? "0px" : undefined,
                              marginRight: !isMargin ? "0" : undefined,
                            },
                            "&.MuiFormControlLabel-root>span": {
                              fontSize: "14px",
                            },
                          }}
                                        key={index}
                                        control={
                                            <Checkbox
                                                checked={value.includes(option.value)}
                                                defaultValue={option.value}
                                                disabled={isDisabled}
                                                checkedIcon={specialTick ? <CloseIcon sx={{ background: "#4db445", color: "#fff", borderRadius: "50%"}}/> : undefined}
                                                onChange={(e) => {
                                                    const newValue = [...value];
                                                    if (e.target.checked) {
                                                        newValue.push(option.value);
                                                    } else {
                                                        newValue.splice(newValue.indexOf(option.value), 1);
                                                    }
                                                    onChange(newValue);
                                                }}
                                                sx={{
                                "& .MuiSvgIcon-root": { fontSize: 18 },
                                padding: isHorizantalPadding
                                  ? "0 1px"
                                  : "1px 0px",
                                "&.Mui-disabled": {
                                  color: (theme) => theme.palette.primary.main,
                                },
                              }}
                                            />
                                        }
                                        label={option.label}
                                    />
                                ))}
                                </FormGroup>
                                {/* {error && <FormHelperText>{error.message}</FormHelperText>} */}
                            </>
                        )}
                    />
                    {errors[name] && <FormHelperText>{errors[name].message}</FormHelperText>}
                </FormControl>
            </> :
                <>
                    <FormControl error={Boolean(errors[name])}>
                        <Controller
                            name={name}
                            control={control}
                            render={({ field }) => (
                                <FormControlLabel
                                    control={<Checkbox {...field} />}
                                    label={label}
                                />
                            )}
                        />
                        {errors[name] && <FormHelperText>{errors[name].message}</FormHelperText>}
                    </FormControl>
                </>}

        </>
    );
};

export default CheckboxController;